import appsData from '../constants/apps.json';

/**
 * Get the display name for an app by its ID
 * @param {string} appId - The app ID/abbreviation (e.g., "quickbooks", "xero")
 * @returns {string} The display name of the app (e.g., "QuickBooks", "Xero")
 */
export function getAppDisplayName(appId) {
  if (!appId) return '';
  
  const app = appsData.find(app => app.id === appId || app.short_name === appId);
  return app ? app.name : appId; // Fallback to original ID if not found
}